/**
 * Created by anthony on 7/3/14.
 */
/**
 * Created by anthony on 7/3/14.
 */
var abstractModel = angular.module('abstractModel', []);
abstractModel.service('AbstractModelService', function(RestService){
    return {
        get: function(endpoint, instance)
        {
            if (typeof instance == 'undefined')
                return RestService.get(endpoint);
            else
            {
                return RestService.get(endpoint)
                    .error(function(data, status, headers, config)
                    {
                        instance.options.callMe(data, status, headers, config, instance);
                    })
                    .success(function(data, status, headers, config)
                    {
                        instance.options.callMe(data, status, headers, config, instance);
                    });
            }
        },
        put: function(endpoint, data, instance)
        {
            if (typeof instance == 'undefined')
                return RestService.put(endpoint, data);
            else
            {
                return RestService.put(endpoint, data)
                    .error(function(data, status, headers, config)
                    {
                        instance.options.callMe(data, status, headers, config, instance);
                    })
                    .success(function(data, status, headers, config)
                    {
                        instance.options.callMe(data, status, headers, config, instance);
                    });
            }
        },
        post: function(endpoint, data, instance)
        {
            if (typeof instance == 'undefined')
                return RestService.post(endpoint, data);
            else
            {
                return RestService.post(endpoint, data)
                    .error(function(data, status, headers, config)
                    {
                        instance.options.callMe(data, status, headers, config, instance);
                    })
                    .success(function(data, status, headers, config)
                    {
                        instance.options.callMe(data, status, headers, config, instance);
                    });
            }
        },
        purge: function(endpoint, data, instance)
        {
            if (typeof instance == 'undefined')
                return RestService.purge(endpoint);
            else
            {
                return RestService.purge(endpoint)
                    .error(function(data, status, headers, config)
                    {
                        instance.options.callMe(data, status, headers, config, instance);
                    })
                    .success(function(data, status, headers, config)
                    {
                        instance.options.callMe(data, status, headers, config, instance);
                    });
            }
        }
    }
});